import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../constants/config';
import { createBaseQuery } from './baseQuery';

export interface UserProfile {
  clientId: string;
  name: string;
  organizationId: string;
  scope: string;
  hasClients: boolean;
  role?: string;
}

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: createBaseQuery(config.apiUrl),
  tagTypes: ['UserProfile'],
  endpoints: (builder) => ({
    getUserProfile: builder.query<UserProfile, void>({
      query: () => `/api/profile`,
      providesTags: ['UserProfile'],
    }),
  }),
});

export const { useGetUserProfileQuery } = userApi;